"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitValidation = void 0;
var determineMinimumPriceByKeyword_1 = require("./determineMinimumPriceByKeyword");
var calcRoadConstructionPrice_1 = require("./calcRoadConstructionPrice");
// Submitボタンをクリックしたときに実行する関数
var submitValidation = function () {
    console.log('submitValidation');
    // Submitボタンを取得
    var submitButtons = document.querySelectorAll('.gform-estimated-items');
    var isProcessing = false; // 処理中フラグ
    var _loop_1 = function (submitButton) {
        submitButton.addEventListener('click', function (event) {
            // 処理中なら実行しない
            if (isProcessing) {
                event.preventDefault();
                return;
            }
            try {
                isProcessing = true; // 処理開始
                handleSubmit(submitButton, function () {
                    isProcessing = false; // 処理完了時にフラグをリセット
                });
            }
            catch (error) {
                console.error('Submit error:', error);
                isProcessing = false; // エラー時もフラグをリセット
            }
        });
    };
    for (var _i = 0, _a = Array.from(submitButtons); _i < _a.length; _i++) {
        var submitButton = _a[_i];
        _loop_1(submitButton);
    }
};
exports.submitValidation = submitValidation;
var handleSubmit = function (btn, onComplete) {
    console.log('handleSubmit');
    // フォームIDを取得
    var getFormId = btn.dataset.gformId;
    // フォームを取得
    var gform = document.querySelector("form#gform_".concat(getFormId));
    if (gform === null) {
        onComplete();
        return;
    }
    // 合計金額入力欄を取得
    var totalPriceInput = document.querySelector('input[name="input_23"]');
    if (totalPriceInput === null) {
        onComplete();
        return;
    }
    var ifRoadConstruction = window.location.pathname.includes('road-construction');
    var parseTotalPrice = parsePrice(totalPriceInput.value); // 合計金額
    var numberValue = ifRoadConstruction
        ? (0, calcRoadConstructionPrice_1.calcRoadConstructionPrice)(parseTotalPrice) // 道路工事の場合は諸経費を追加する
        : parseTotalPrice;
    var minPrice = (0, determineMinimumPriceByKeyword_1.determineMinimumPriceByKeyword)(numberValue); // 最低金額
    if (numberValue < minPrice) {
        if (showConfirmationDialog(minPrice)) {
            totalPriceInput.value = minPrice.toString();
            gform.submit();
        }
        else {
            onComplete(); // キャンセル時はフラグをリセット
        }
    }
    else {
        gform.submit();
    }
};
// 合計金額を文字列から数値に変換
var parsePrice = function (value) {
    return Number.parseInt(value.replace(/,/g, '').trim(), 10);
};
// 最低見積金額の確認ダイアログを表示
var showConfirmationDialog = function (minPrice) {
    return confirm("\u5408\u8A08\u91D1\u984D\u304C".concat(minPrice.toLocaleString(), "\u5186\u4EE5\u4E0B\u306E\u5834\u5408\u3001\u91D1\u984D\u306F").concat(minPrice.toLocaleString(), "\u5186\u306B\u5F15\u304D\u4E0A\u3052\u3089\u308C\u307E\u3059\u3002\n\u3053\u306E\u307E\u307E\u9001\u4FE1\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B?"));
};
